import type { Components } from '@mui/material';

export const MuiButton: Components['MuiButton'] = {
  defaultProps: {
    size: 'large',
  },
  styleOverrides: {
    root: {
      textTransform: 'none',
      borderRadius: '5px',
      padding: '9px 26px',
    },
    containedPrimary: {
      background: 'linear-gradient(275deg, #8FFF00 -16.97%, #DBFF00 129.69%)',
      boxShadow: '0px 11px 15px 0px rgba(20, 255, 15, 0.17)',
    },
    sizeMedium: {
      fontSize: '16px',
    },
    sizeLarge: {
      fontSize: '18px',
    },
  },
};